import { ReleaseNoteRequestDTO, ReleaseNoteResponseDTO } from 'typings/dto/releaseNote';
import ModelActionsService from '../ModelActionsService';
import NavigateFrontendUtils from 'utils/NavigateFrontend';

export default class ReleaseNoteActionService extends ModelActionsService<ReleaseNote, ReleaseNoteRequestDTO, ReleaseNoteResponseDTO> {
  protected getDefaultSortFilter<T extends LocationSearchObject>(filter?: T): T {
    return super.getDefaultSortFilter(filter, 'releaseDate', NavigateFrontendUtils.SORT_ORDER.desc);
  }
}
